module.exports = __webpack_public_path__ + "img/People-low.a874a3dd.jpg";